import { useMemo } from "react";
import { ColumnDef } from "@components/spreadsheet/types";
import { buildPeriodColumns } from "@components/tasks/TaskBody/BalanceSheet/balanceSheetTaskColumns";
import { getDefaultExpandedIds } from "@components/tasks/TaskBody/BalanceSheet/balanceSheetTaskRows";
import { useBalanceSheetReport } from "@components/tasks/TaskBody/BalanceSheet/useBalanceSheetReport";
import { LABEL_COLUMN } from "@components/tasks/TaskBody/shared/reportTaskColumns";
import { useExpandCollapseAll } from "@components/tasks/TaskBody/shared/useExpandCollapseAll";
import { TemplateReportGrid } from "./TemplateReportGrid";
import { TemplateReportQueryState } from "./TemplateReportQueryState";
import { TemplateReportTableProps } from "./templateReportTable.types";

export const TemplateBalanceSheetDataTable = ({
    entityId,
    dateRange,
    cycle,
    comparisonOptions,
    canSwitchEntity,
}: TemplateReportTableProps) => {
    const { balanceSheet, rows, ledgerId, ledgersQuery } =
        useBalanceSheetReport({
            entityId,
            dateRange,
            cycle,
            comparisonOptions,
        });

    const columns = useMemo(
        (): ColumnDef[] => [
            LABEL_COLUMN,
            ...buildPeriodColumns({
                periods: balanceSheet.data?.periods ?? [],
            }),
        ],
        [balanceSheet.data],
    );
    const defaultExpandedIds = useMemo(
        () => (rows ? getDefaultExpandedIds(rows) : []),
        [rows],
    );
    const expandState = useExpandCollapseAll(rows, defaultExpandedIds);

    return (
        <TemplateReportQueryState
            queryResult={balanceSheet}
            ledgerId={ledgerId}
            ledgersQuery={ledgersQuery}
            canSwitchEntity={canSwitchEntity}
            reportLabel="balance sheet"
        >
            {balanceSheet.data && rows && (
                <TemplateReportGrid
                    rows={rows}
                    columns={columns}
                    expandState={expandState}
                />
            )}
        </TemplateReportQueryState>
    );
};
